<template>
  <div class="page-container">
    <van-nav-bar
      left-arrow
      fixed
      :z-index="10"
      @click-left="goableBack()"
      :title="$route.params.title"></van-nav-bar>
    <div id="bi-div" class="content">
      <iframe
        id="content_iframe"
        frameborder="0"
        marginwidth="0"
        marginheight="0"
        scrolling="auto"
        width="100%"
        height="100%"
        allowtransparency="true"
        :src="$route.params.url">
      </iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "webview",
  data: () => ({}),
  mounted() {
    // let frame =
    //   '<iframe frameborder="no" border="0" marginwidth="0" marginheight="0" scrolling="auto" width="100%" height="100%" allowtransparency="true" src="' +
    //   this.$route.params.url +
    //   '"></iframe>'
    // let newNode = document.createElement("div")
    // newNode.innerHTML = frame
    // newNode.style.height = "100vh"
    // let htmlBody = document.getElementById("bi-div")
    // htmlBody.insertBefore(newNode, htmlBody.firstChild)
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.content {
  padding: 0px;
  height: 100vh;
  background-color: antiquewhite;
}
.van-nav-bar {
  background: #fff;

  ::v-deep .van-nav-bar__title {
    color: @dark;
  }
  ::v-deep .van-icon {
    color: @dark !important;
  }
}
</style>